export default {
  description: '',
  promotionTypeOptin: false,
  texts: {
    regularPriceOverrideText: null,
    promotionPriceOverrideText: null,
    minimumCommitmentPeriodOverrideText: null,
  },
  price: {
    /* amount: 9.9, */
    chargingIntervalFactor: 1,
    chargingIntervalOverrideText: null,
    chargingIntervalUnit: 3,
    /* currency: 'EUR', */
    isExact: true,
    minimumCommitmentPeriodFactor: 24,
    minimumCommitmentPeriodUnit: 3,
    priceDisplay: '9,90 €',
    /* value: '9.90', */
    promotion: {
      /* amount: 4.5, */
      /* currency: 'EUR', */
      durationFactor: 1,
      durationUnit: 3,
      priceDisplay: '4,50 €',
      promotionEnd: null,
      /* value: '4.50', */
      setupPrice: {
        /* amount: 0.5, */
        /* currency: 'EUR', */
        priceDisplay: '0,50 €',
        /* value: '0.50', */
      },
    },
    setupPrice: {
      /* amount: 1.23, */
      /* currency: 'EUR', */
      priceDisplay: '1,23 €',
      /* value: '1.23', */
    },
  },
};
